import { ref } from "vue";
import { useCommon } from "../../composition-functions/common";
import { Portal } from "../../composition-functions/portal/Portal";
import { PortalType } from "../../composition-functions/portal/PortalType";
import { IDeletePortalParams, IGetPortalParams, ISavePortalParams } from "./IParams";

const currentPortal = ref<null | Portal>(null);

async function deletePortal({ portalId }: IDeletePortalParams) {
  const { deleteRequest } = useCommon();
  await deleteRequest({ path: `/admin/portals/${portalId}` });
}

async function getPortal({ portalId }: IGetPortalParams): Promise<Portal> {
  const { getRequest } = useCommon();

  const response = await getRequest({ path: `/admin/portals/${portalId}` });
  const result = await response.json();
  return result;
}

async function refreshCurrentPortal(params: IGetPortalParams): Promise<void> {
  currentPortal.value = await getPortal(params);
}

async function getPortalTypes(): Promise<PortalType[]> {
  const { getRequest } = useCommon();

  const response = await getRequest({ path: "/admin/portals/portalTypes" });
  const result = await response.json();
  return result;
}

async function savePortal({ portal }: ISavePortalParams): Promise<{ id: number }> {
  const { postRequest } = useCommon();

  const response = await postRequest({ path: "/admin/portals", data: JSON.stringify(portal) });
  const result = await response.json();
  return result;
}

export const usePortal = () => {
  return {
    deletePortal,
    getPortal,
    getPortalTypes,
    savePortal,
    refreshCurrentPortal,
    currentPortal,
  };
};
